import { render } from "./Steps-progress.vue?vue&type=template&id=f4f0715a"
import script from "./Steps-progress.vue?vue&type=script&lang=js"
export * from "./Steps-progress.vue?vue&type=script&lang=js"
script.render = render

export default script